import React, { useState } from "react";
import Pagination from "@mui/material/Pagination";
export default function AnalysisPagination({ count, data }) {
  const [pagenation, setpagenation] = useState(0);
  return (
    <>
      <div className="m-2 w-full p-4 flex items-center justify-center flex-col">
        <Pagination
          count={count}
          variant="outlined"
          shape="rounded"
          onChange={(e, value) => setpagenation(value - 1)}
        />
        <div className="form-control w-full ">
          <textarea
            disabled
            value={data[pagenation]}
            className="textarea textarea-bordered h-48 m-4"
          ></textarea>
        </div>
      </div>
    </>
  );
}
